import { gql } from "@apollo/client";

export const LOGIN_QUERY = gql`
  query VerifyLogin($email_address: String, $password: String!, $name: String) {
    verifyLogin(
      email_address: $email_address
      password: $password
      name: $name
    ) {
      request_status
      access_token
      refresh_token
    }
  }
`;

export const QUERY_USER = gql`
  query QueryUser($input: getUserInput) {
    queryUser(input: $input) {
      id
      name
      first_name
      last_name
      display_name
      legal_name
      date_of_establishment
      email_address
      createdAt
      profile_bio
      privacy_level
      problem_praise_tab
      status
      account_type
      verification_status
      is_political_party
      party_election_symbol {
        url
        thumbnail_url
      }
      profile_banner {
        url
        thumbnail_url
      }
      follower_count
      following_count
      patron_count
      patronage_count
      influence_count
      profile_picture {
        url
      }
      location {
        type
        coordinates
      }
      praise_posts
      problem_posts
      total_posts
    }
  }
`;
export const USER_VERIFICATION_STATUS_QUERY = gql`
  query QueryUser($input: getUserInput) {
    queryUser(input: $input) {
      id
      verification_status
    }
  }
`;
export const SETTING_QUERY_USER = gql`
  query QueryUser($input: getUserInput) {
    queryUser(input: $input) {
      id
      name
      email_address
      first_name
      last_name
      display_name
      legal_name
      date_of_establishment
      profile_bio
      privacy_level
      status
      account_type
      verification_status
      follower_count
      following_count
      patron_count
      patronage_count
      influence_count
      party_election_symbol {
        url
        thumbnail_url
      }
      is_political_party
      profile_picture {
        url
      }
      profile_banner {
        url
        thumbnail_url
      }
      location {
        type
        coordinates
      }
    }
  }
`;
export const GET_INFLUENCE_COUNT = gql`
  query GetInfluenceCount($user_id: ID!, $level: Int) {
    getInfluenceCount(user_id: $user_id, level: $level) {
      influence_count
      level
    }
  }
`;

export const REFRESH_TOKEN_QUERY = gql`
  query GetAccessToken {
    getAccessToken {
      access_token
    }
  }
`;

export const SIGNUP_MUTATION = gql`
  mutation AddUser(
    $name: String!
    $email_address: String!
    $password: String!
  ) {
    addUser(
      input: { name: $name, email_address: $email_address, password: $password }
    ) {
      request_status
      id
      access_token
      refresh_token
    }
  }
`;

export const SEND_OTP_MUTATION = gql`
  mutation SendOtp($user_id: ID!) {
    sendOtp(user_id: $user_id)
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation VerifyOtp($user_id: ID!, $otp_code: Int!) {
    verifyOtp(user_id: $user_id, otp_code: $otp_code)
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($input: UserUpdateInput!) {
    updateUser(input: $input)
  }
`;

export const PASSWORD_RESET = gql`
  mutation passwordReset($email: String!) {
    passwordReset(email_address: $email)
  }
`;

export const VERIFY_RESET_PASSWORD = gql`
  mutation verifyResetPassword($token: String!, $password: String!) {
    verifyResetPassword(token: $token, password: $password)
  }
`;
